import { Encode_Sans } from 'next/font/google';
import { pet } from '@angeplus/prever-component-lib';
import { AppLayout } from '@angeplus/prever-component-lib/nextjs';
import { logger } from '@ferreri/minato-logger-next';
import { AppProps } from 'next/app';

import {
  customQueryClient,
  QueryClientProvider,
} from '@ferreri/minato-react-utils';

import { PAGE_TITLE } from '../utils/pageTitle';
import { SETTINGS } from '../config/settings';

const encodeSans = Encode_Sans({
  subsets: ['latin'],
  weight: [
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '700',
    '800',
    '900',
  ],
  variable: '--font-family-01',
});

logger.setBasePath(SETTINGS.public.basePath ?? '');

// This default export is required in a new `pages/_app.js` file.
export default function MyApp({ Component, pageProps }: AppProps) {
  return (
    <QueryClientProvider client={customQueryClient}>
      <AppLayout
        productName="ParaSeuPet"
        projectName="televet"
        tmsToken={SETTINGS.public.tmsToken}
        fontFamily={encodeSans.variable}
        theme={pet}
        defaultTitle={PAGE_TITLE.base}
      >
        <Component {...pageProps} />
      </AppLayout>
    </QueryClientProvider>
  );
}
